import { ROW_GRID_TEMPLATE } from "./tooltipRowStyle"

// The fixed top of the tooltip: the chart title with the current year, then the
// column labels aligned to the same grid the rows below use.
export const TooltipHeader = ({
  year,
  unitHeader,
}: {
  year: number
  unitHeader: string
}) => (
  <>
    <div className="flex font-mono justify-between items-center border-b border-black/15 pb-2 mb-3 -mx-4 px-4">
      <div className="text-[12px] font-semibold tracking-wide uppercase">
        Distribution of Power
      </div>
      <div className="text-[12px] font-semibold tracking-wide opacity-100">
        {year}
      </div>
    </div>
    <div
      className="grid items-center gap-2 font-mono pr-2"
      style={{ gridTemplateColumns: ROW_GRID_TEMPLATE }}
    >
      <span aria-hidden/>
      <span className="overflow-hidden text-ellipsis whitespace-nowrap text-[12px] font-semibold tracking-wide" style={{ minWidth: 0 }}>Name</span>
      <span className="text-[11px] tracking-wide font-semibold text-right">
        {unitHeader}
      </span>
    </div>
    <div className="border-t border-white/15 mb-1" />
  </>
)
